import AutoAssignerTimeZoneEditPage from 'components/pages/admin/auto-assigner-time-zones/auto-assigner-time-zone-edit-page'

export default AutoAssignerTimeZoneEditPage
